<template>
    <div class="container-fluid">
        <div class="row d-flex justify-content-center">
            <div class="col-11 mb-3 mb-lg-5">
                <div class="card table-nowrap table-card">
                    <div class="table-responsive">
                        <table class="table mb-0 table-striped">
                            <thead class="small text-uppercase bg-body text-muted">
                                <tr>
                                    <th class="align-middle">
                                        <div class="form-check col-auto">
                                            <input @click="this.change(); this.globalCheck = !this.globalCheck; this.checkAll()" type="checkbox" v-model="globalCheck" class="form-check-input p-2 border border-5 border-dark-subtle">
                                        </div>
                                    </th>
                                    <th class="align-middle">Tout</th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading">
                                <tr v-for="balise in balises" :key="balise.id">
                                    <td>
                                        <div class="form-check col-auto">
                                            <input @click="this.change()" type="checkbox" v-model="balise.checked" class="form-check-input p-2 border border-5 border-dark-subtle">
                                        </div>
                                    </td>
                                    <td>
                                        <VehicleNameDisplay :balise="balise"/>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="2" class="text-center">
                                        <LoaderDisplay/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleNameDisplay from '../../../components/display/VehicleNameDisplay.vue'
import LoaderDisplay from '../../../components/display/LoaderDisplay.vue'

export default {
    props: ['balises', 'loading'],
    components: {
        VehicleNameDisplay,
        LoaderDisplay
    },
    data () {
        return {
            globalCheck: false
        }
    },
    methods: {
        change() {
            this.$emit("change");
        },
        checkAll() {
            this.balises.forEach(balise => {
                balise.checked = this.globalCheck
            });
        }
    }
}
</script>